import React from 'react'
import { Router, withSiteData, Head } from 'react-static'
import { hot } from 'react-hot-loader'
import Routes from 'react-static-routes'

import Nav from './components/Nav'
import './sass/app.scss'

const App = withSiteData(({ data }) => [
  <Head key="app-head">
    <meta charSet="UTF-8" />
  </Head>,
  <div className="container" key="app-content">
    <Router>
      <div>
        <Nav data={data} />
        <div className="content">
          <Routes />
        </div>
      </div>
    </Router>
  </div>,
])

export default hot(module)(App)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js